var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import camelcaseKeys from 'camelcase-keys';
import { OfferTypes } from '../types';
import { OFFER_TYPE_DOLLAR, OFFER_TYPE_PERCENT, OFFER_TYPE_PERCENT_DOLLAR, } from '../../components/PaymentCalculator/ViewOffers/constants';
import isNonNullable from '../../utils/isNonNullable';
var additionalSavingsOfferNames = ['Military Discount', 'Newcomer to Canada', 'Student Discount'];
var parseIncentiveOffer = function (offer) {
    var type = OfferTypes[offer.type];
    if (additionalSavingsOfferNames.includes(offer.name)) {
        type = OfferTypes.AdditionalSavings;
    }
    else {
        type = offer.type;
    }
    return __assign(__assign({}, offer), { id: Number(offer.id) || 0, isSelected: false, value: Number(offer.value), type: type, key: offer.id.toString() });
};
var parseLoyaltyOffer = function (offer) {
    var _a, _b;
    var loyaltyOfferStub = {
        key: offer.key,
        type: offer.type,
        term: 0,
        id: 0,
        isSelected: false,
    };
    if (offer.type !== OFFER_TYPE_PERCENT_DOLLAR) {
        return __assign(__assign(__assign({}, loyaltyOfferStub), offer), { value: Number(offer.value) });
    }
    var splitOffers = "".concat(offer.value).split(',').map(function (rawValue, idx) {
        var value = Number(rawValue.trim());
        if (!value)
            return null;
        var nameSuffix = offer.name.substring(offer.name.indexOf(' '));
        if (idx === 0) {
            return __assign(__assign({}, loyaltyOfferStub), { value: value, type: OFFER_TYPE_PERCENT, name: "".concat(value * 100, "%").concat(nameSuffix) });
        }
        if (idx === 1) {
            return __assign(__assign({}, loyaltyOfferStub), { value: value, type: OFFER_TYPE_DOLLAR, name: "$".concat(value).concat(nameSuffix) });
        }
        return null;
    });
    return ((_a = splitOffers[1]) === null || _a === void 0 ? void 0 : _a.value) ? splitOffers[1] : (_b = splitOffers[0]) !== null && _b !== void 0 ? _b : null;
};
var defaultOffer = {
    lease: [],
    finance: [],
    cash: [],
};
var transformOffersResponse = function (response) {
    var _a;
    var camelCasedData = camelcaseKeys(response, { deep: true }) || [];
    return (_a = camelCasedData === null || camelCasedData === void 0 ? void 0 : camelCasedData.map) === null || _a === void 0 ? void 0 : _a.call(camelCasedData, function (item) { return (__assign(__assign({}, item), { loyaltyOffers: item.loyaltyOffers
            ? __assign(__assign({}, item.loyaltyOffers), { lease: item.loyaltyOffers.lease.map(parseLoyaltyOffer).filter(isNonNullable), finance: item.loyaltyOffers.finance.map(parseLoyaltyOffer).filter(isNonNullable), cash: item.loyaltyOffers.cash.map(parseLoyaltyOffer).filter(isNonNullable) }) : defaultOffer, incentiveOffers: item.incentiveOffers
            ? __assign(__assign({}, item.incentiveOffers), { lease: item.incentiveOffers.lease.map(parseIncentiveOffer), finance: item.incentiveOffers.finance.map(parseIncentiveOffer), cash: item.incentiveOffers.cash.map(parseIncentiveOffer) }) : defaultOffer })); });
};
export default transformOffersResponse;
